import { ReactNode, useEffect, useState } from "react";
import createPersistedState from "../src/createPersistedState";

export enum ClickMeID {
  ModelerERDNode = "ModelerERDNode",
}

const usePersistedState =
  createPersistedState<Partial<{ [clickMeID in ClickMeID]: true }>>("click_me");

/** parent must be relatively positioned */
export function useClickMe(
  id: ClickMeID,
  message: string
): {
  clearClickMe: () => void;
  clickMe: ReactNode;
} {
  const [persistedState, setPersistedState] = usePersistedState({});
  const [animation, setAnimation] = useState(false);
  const clearClickMe = () => {
    setPersistedState({ ...persistedState, [id]: true });
  };
  const shouldMount = !(id in persistedState);
  useEffect(() => {
    if (shouldMount) {
      const interval = setInterval(() => {
        setAnimation(false);
        setAnimation(true);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [shouldMount]);
  const clickMe = shouldMount ? (
    <div
      className={`absolute rounded-full border-8 border-blue-500 right-1 bottom-1 duration-1000 ease-out ${
        animation
          ? "ring-8 ring-transparent transition-shadow"
          : "ring-0 ring-blue-500 transition-none"
      }`}
    >
      <div className="absolute inset-0 flex items-center">
        <div className="ml-1 border-r-8 border-y-8 border-gray-700 border-y-transparent"></div>
        <div className="bg-gray-700 px-2 py-1 text-gray-100 rounded-lg text-xs">
          {message}
        </div>
      </div>
    </div>
  ) : null;
  return { clearClickMe, clickMe };
}
